export default "__VITE_ASSET__CoV_w3mX__"